import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTouchDragList = createSharedCachedFactory((): Array<TouchEvent> => {
  return []
})
